import React, {Component} from 'react';
// import TemplateHeaderLogo from "./TemplateHeaderLogo";
import './NavigationDropdown.css';
import NavigationDropdown from './NavigationDropdown';
import TemplateHeaderLogo from './TemplateHeaderLogo';

/**
 * This is a static react port of the cdc template header for 4.5
 */
export default class TemplateHeader extends Component {

  render() {
    return (
      <div className="container-fluid header-wrapper">
        <div className="container-fluid bg-gradient py-2">
        <header id="page_banner" role="banner" aria-label="Banner">
            <div className="container-fluid header-wrapper">
                <div className="container">
                   <div className="row align-items-center p-2">
                      <div className="col-10 col-md-11 d-flex align-items-center p-0">
                         <TemplateHeaderLogo alt="CDC Logo"/>
                         <div className="display-6 text-white pt-1 pb-1 site-title-inner">
                            <a href="/" className="text-white text-decoration-none ml-3">WISQARS
                            <br /><span className="d-none d-lg-block ml-3">Web-based Injury Statistics Query and Reporting System</span></a>
                        </div>
                      </div>
                      <div className="col-2 col-md-1 d-flex justify-content-end pr-0">
                         <NavigationDropdown />
                      </div>
                   </div>
                </div>
            </div>
        </header>
        </div>
      </div>
    );
  }

}
